(function () {
  'use strict';

  var loadedApps = {};
  var marketingAllowed = false;
  var blockedMarketingScriptPatterns = [
    'kochalpin.activehosted.com/js/site-tracking.php',
    'cdn.growthhero.io/sites/pixel.js'
  ];

  function isBlockedMarketingScript(node) {
    if (marketingAllowed || !node || node.tagName !== 'SCRIPT') {
      return false;
    }

    var src = node.src || node.getAttribute('src') || '';

    return blockedMarketingScriptPatterns.some(function (pattern) {
      return src.indexOf(pattern) !== -1;
    });
  }

  function blockAutomaticMarketingScripts() {
    var originalAppendChild = Node.prototype.appendChild;
    var originalInsertBefore = Node.prototype.insertBefore;

    Node.prototype.appendChild = function (node) {
      if (isBlockedMarketingScript(node)) {
        return node;
      }

      return originalAppendChild.call(this, node);
    };

    Node.prototype.insertBefore = function (node, referenceNode) {
      if (isBlockedMarketingScript(node)) {
        return node;
      }

      return originalInsertBefore.call(this, node, referenceNode);
    };
  }

  function loadScriptOnce(name, src, attributes) {
    if (loadedApps[name] || document.querySelector('[data-consent-controlled-app="' + name + '"]')) {
      return;
    }

    loadedApps[name] = true;

    var script = document.createElement('script');
    script.src = src;
    script.setAttribute('data-consent-controlled-app', name);

    Object.keys(attributes || {}).forEach(function (attribute) {
      script[attribute] = attributes[attribute];
    });

    script.addEventListener('error', function () {
      loadedApps[name] = false;

      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    }, { once: true });

    document.head.appendChild(script);
  }

  function loadOneClickPopup() {
    window.OneClickPopup = window.OneClickPopup || {};

    loadScriptOnce(
      'one-click-popup',
      'https://popup.1clicklabs.io/widget.js?v=dda8598c3056382a128e25ada3bb2cf3',
      { async: true, type: 'text/javascript' }
    );
  }

  function loadActiveCampaign() {
    loadScriptOnce(
      'active-campaign',
      'https://cdn.shopify.com/proxy/4da4428c6b73e1d2cbd7c1a25655a2c9dc2bd229c7e03f95f5de763b31a6f46d/kochalpin.activehosted.com/js/site-tracking.php?shop=zenbivy-europe.myshopify.com&sp-cache-control=cHVibGljLCBtYXgtYWdlPTkwMA',
      { async: true, type: 'text/javascript' }
    );
  }

  function loadGrowthHero() {
    loadScriptOnce(
      'growth-hero',
      'https://cdn.growthhero.io/sites/pixel.js?shop=zenbivy-europe.myshopify.com',
      { async: true, type: 'text/javascript' }
    );
  }

  function applyConsent(preferences) {
    if (preferences && preferences.marketing) {
      marketingAllowed = true;
      loadOneClickPopup();
      loadActiveCampaign();
      loadGrowthHero();

      return;
    }

    if (preferences && marketingAllowed) {
      window.location.reload();
    }
  }

  document.addEventListener('consentmoSignal', function (event) {
    applyConsent(event.detail && event.detail.preferences);
  });

  document.addEventListener('consentmoSignal_onLoad', function (event) {
    var consentmoState = event.detail || { isActive: false };

    if (!consentmoState.isActive) {
      loadOneClickPopup();
      marketingAllowed = true;
      loadActiveCampaign();
      loadGrowthHero();
    }
  });

  blockAutomaticMarketingScripts();
})();
